import moment from 'moment';

export function isValidDob(dob) {
    const age = moment(dob);
    const now = moment();
    if (!age.isValid() || now.diff(age, 'years') < 18) return false;
    return true;
}

export const sortByAsc = (arr, propertyForSort) => {
    return arr && arr.sort((a, b) => {
        if (!a[propertyForSort] && b[propertyForSort]) return -1;
        if (a[propertyForSort] && !b[propertyForSort]) return 1;
        return a[propertyForSort] > b[propertyForSort] ? 1 : -1;
    });
};

export const setModalityCase = (name) => {
    switch (name) {
    case 'ct scan':
        return 'CT';
    case 'ct':
        return 'CT';  
    case 'xray':
        return 'X-ray';
    case 'mri':
        return 'MRI';
    case 'pet':
        return 'PET';
    case 'mr':
        return 'MR';
    default:
        return `${name.slice(0,1).toUpperCase()}${name.slice(1)}`;
    }
};

export function convertUTCToLocalTimeWithAMPM(utcTimeStr) {
  const today = new Date();
  const [hours, minutes, seconds] = utcTimeStr.split(":");

  const utcDate = new Date(Date.UTC(
    today.getUTCFullYear(),
    today.getUTCMonth(),
    today.getUTCDate(),
    Number(hours),
    Number(minutes),
    Number(seconds)
  ));

  let localHours = utcDate.getHours();
  const ampm = localHours >= 12 ? 'PM' : 'AM';

  localHours = localHours % 12;
  localHours = localHours ? localHours : 12;

  const localMinutes = String(utcDate.getMinutes()).padStart(2, '0');
  const localSeconds = String(utcDate.getSeconds()).padStart(2, '0');

  return `${localHours}:${localMinutes}:${localSeconds} ${ampm}`;
}

export function extractLocalTimeParts(utcTimeStr) {
  const today = new Date();
  const [hours, minutes, seconds] = utcTimeStr.split(":");

  const utcDate = new Date(Date.UTC(
    today.getUTCFullYear(),
    today.getUTCMonth(),
    today.getUTCDate(),
    Number(hours),
    Number(minutes),
    Number(seconds)
  ));

  let localHour = utcDate.getHours();
  const ampm = localHour >= 12 ? 'PM' : 'AM';

  localHour = localHour % 12 || 12;
  const localMinute = String(utcDate.getMinutes()).padStart(2, '0');

  return {
    hour: localHour,
    minute: localMinute,
    period: ampm
  };
}

 export function hasUnderscore(id) {
  return typeof id === 'string' && id.includes('_');
}

export const prepareFollowUpStatusReq = (status) => {
    if(!status) {
        return '';
    }
    const makeStatusParam = (status) => `status=${status.trim().replace(' ', '_').toLowerCase()}&`;
    return typeof status === 'string' ? makeStatusParam(status) :
        status.map(({status}) => makeStatusParam(status));
};

export const generateColor = () => {
    const userColors = ['#D6CFFF', '#FFCFCF', '#FFCFFA', '#EDFFCF', '#CFFCFF'];
    return userColors[Math.floor(Math.random() * userColors.length)];
};

export const formatDate = (date) => {
    const _date = moment(date);
    if(!_date.isValid()) {
        return "";
    }
    return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
}

export function capitalizeWords(str) {
    const words = str?.split(/[_\s]+/);

    const capitalizedWords = words?.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );

    const capitalizedString = capitalizedWords?.join(" ");

    return capitalizedString;
  }

 export const ALL_SMS_STATUSES_CONFIG = [
  { status: 'sent', label: 'Sent', color: '#FDBB13' },
  { status: 'delivered', label: 'Delivered', color: '#64C67C' },
  { status: 'bounced', label: 'Bounced', color: '#FF5F65' },
  { status: 'drafted', label: 'Drafted', color: '#00AEEF' },
  { status: 'attempted', label: 'Attempted', color: '#DFE0EB' },
  { status: 'clicked', label: 'Clicked', color: '#4EAC9F' },
  { status: 'converted', label: 'Converted', color: '#FF7A00' },
  { status: 'failed', label: 'Failed', color: '#9B64C6' },
  { status: 'undeliverable', label: 'Undeliverable', color: '#C2C2C2' }
];

export const ALL_FAX_STATUSES_CONFIG = [
    { status: 'failed', label: 'Failed', color: '#9B64C6' },
    { status: 'success', label: 'Success', color: '#64C67C' },
    { status: 'cancelled', label: 'Cancelled', color: '#CF3131' },
  { status: 'processing', label: 'Processing', color: '#ADADAD' },
  { status: 'transmitting', label: 'Transmitting', color: '#FF7A00' }
];

 export const ALL_MAIL_STATUSES_CONFIG = [
  { status: 'sent', label: 'Sent', color: '#FDBB13' },
  { status: 'delivered', label: 'Delivered', color: '#64C67C' },
  { status: 'opened', label: 'Opened', color: '#00AEEF' }, 
  { status: 'clicked', label: 'Clicked', color: '#4EAC9F' },
  { status: 'spammed', label: 'Spammed', color: '#7C7C7C' }, 
  { status: 'failed', label: 'Failed', color: '#9B64C6' },
  { status: 'dropped', label: 'Dropped', color: '#CF3131' }, 
  { status: 'bounced', label: 'Bounced', color: '#FF5F65' },
  { status: 'unsubscribed', label: 'Unsubscribed', color: '#ADADAD' }, 
  { status: 'converted', label: 'Converted', color: '#FF7A00' },
  { status: 'attempted', label: 'Attempted', color: '#DFE0EB' },
];

export const statusColors = {
    // 'drafted': '#8884d8',
    // 'delivered': '#82ca9d',
    // 'sent': '#ffc658',
    // 'failed': '#ff7c7c',
    // 'pending': '#8dd1e1'

      'sent' :'#FDBB13' ,
  'delivered': '#64C67C',
  'opened':'#00AEEF',
  'clicked' :'#4EAC9F' ,
  'spammed': '#7C7C7C',
  'failed':'#9B64C6',
  'dropped':'#CF3131' ,
  'bounced':'#FF5F65',
  'unsubscribed':'#ADADAD', 
  'converted':'#FF7A00',
  'attempted':'#DFE0EB',
  };

  export const computedStatusColors = {
  'not_compliant' :'#FDBB13' ,
  'completed': '#64C67C',
  'scheduled':'#00AEEF',
  'not_completed':'#9B64C6',
  'ordered':'#CF3131' 
  };


 export const processDataByDateOnly = (data) => {
    // Group data by date only, combining all campaigns
    const groupedData = {};
    const allStatuses = new Set();
    
    // First pass: collect all unique statuses and group by date only
    data.forEach(item => {
      const date = new Date(item.created).toISOString().split('T')[0]; // Extract YYYY-MM-DD
      
      allStatuses.add(item.status);
      
      if (!groupedData[date]) {
        groupedData[date] = {
          date,
          statusCounts: {},
          campaigns: new Set(),
          campaignDetails: []
        };
      }
      
      // Add campaign to the set and details
      groupedData[date].campaigns.add(item.cio_campaign_name);
      const existingDetail = groupedData[date].campaignDetails.find(
      detail => detail.campaign === item.cio_campaign_name && detail.status === item.status
    );

    if (existingDetail) {
      existingDetail.count += item.id__count;
    } else {
      groupedData[date].campaignDetails.push({
        campaign: item.cio_campaign_name,
        status: item.status,
        count: item.id__count,
        created: item.created
      });
    }
      
      groupedData[date].statusCounts[item.status] = 
        (groupedData[date].statusCounts[item.status] || 0) + item.id__count;
    });
    
    // Second pass: ensure all statuses are present for each date (fill with 0 if missing)
    const statusArray = Array.from(allStatuses);
    Object.values(groupedData).forEach(group => {
      statusArray.forEach(status => {
        if (!(status in group.statusCounts)) {
          group.statusCounts[status] = 0;
        }
      });
      // Convert campaigns set to array
      group.campaignsArray = Array.from(group.campaigns);
    });
    
    // Convert to array and sort by date
    const result = Object.values(groupedData)
      .map(group => ({
        date: group.date,
        created: group.created,
        // dateLabel: new Date(group.date).toLocaleDateString(),
        campaignsCount: group.campaignsArray.length,
        campaignsList: group.campaignsArray,
        campaignDetails: group.campaignDetails, //gro
        ...group.statusCounts
      }))
      .sort((a, b) => new Date(a.date) - new Date(b.date));
    
    return { processedData: result, statuses: statusArray };
  };

 export function formatMonthYear(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleString('en-US', { month: 'short', year: 'numeric' });
 };



